import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";

function ResumenOm({ institucionId }) {
  const cookies = new Cookies();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Obtener ID correctamente (prioridad: prop > cookie)
  const id = institucionId || cookies.get("institucionid");

  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://suadesarrollo.azurewebsites.net/api/TablaOPModel/${id}`,
          {
            auth: {
              username: "BasicAuth@icontec.org",
              password: "yQLzqmR7eZSuAmQZUqhY",
            },
          },
        );

        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setData({});
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  Resumen de OM
                </h6>
              </div>

              <div className="card-body">
                <hr />

                {loading ? (
                  <p>Cargando...</p>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered" width="100%">
                      <thead>
                        <tr>
                          <th>Total oportunidades</th>
                          <th>Total agrupadas</th>
                          <th>Total solucionadas</th>
                          <th>Total parciales</th>
                          <th>Total reiteradas</th>
                          <th>Total nuevas</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>{data?.totalOportunidades ?? 0}</td>
                          <td>{data?.totalAgrupapas ?? 0}</td>
                          <td>{data?.totalSolucionadas ?? 0}</td>
                          <td>{data?.totalParciales ?? 0}</td>
                          <td>{data?.totalReiteradas ?? 0}</td>
                          <td>{data?.totalNuevas ?? 0}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default ResumenOm;
